import { Tooltip, styled } from '@mui/material'
import React from 'react'

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
  />
))(() => ({
  [`& .MuiTooltip-tooltip`]: {
    background: 'linear-gradient(135deg, #d7f1f8, #c9ccfcff)',
    color: '#1f2937',
    padding: '16px 18px',
    borderRadius: '16px',
    maxWidth: '420px',
    fontSize: '14px',
    lineHeight: 1.6,
    border: '1px solid #e5e7eb',
    boxShadow: `
      0px 4px 10px rgba(0, 0, 0, 0.06),
      0px 15px 25px rgba(0, 0, 0, 0.04)
    `,
  },

  [`& .MuiTooltip-arrow`]: {
    color: '#d7f1f8',
    filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.05))',
  },
}))

const StyledToolTip = ({ children, ...props }) => {
  return (
    <StyledTooltip {...props}>
      <span style={{ cursor: 'pointer' }}>
        {children}
      </span>
    </StyledTooltip>
  )
}

export default StyledToolTip
